import { render, staticRenderFns } from "./msgDialog.vue?vue&type=template&id=c1592f18&scoped=true"
import script from "./msgDialog.vue?vue&type=script&lang=js"
export * from "./msgDialog.vue?vue&type=script&lang=js"
import style0 from "./msgDialog.vue?vue&type=style&index=0&id=c1592f18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1592f18",
  null
  
)

export default component.exports